export default "__VITE_ASSET__DJUl5luL__"